import { PropTypes } from 'prop-types';
import { useEffect, useMemo, useRef, useState } from 'react';

import '../../DrilldownAndDetailSearch.css';

import { CircularProgress, TextField, Chip } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';

import { getPublicAPI } from '@/service/publicService';
import useDebounce from '@/hooks/useDebounce';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import ListboxWithInfiniteScroll from '../ListboxWithInfiniteScroll';
import { onChangeSelectedOptions } from '../../handler/DrilldownAndDetailSearchHandler';
import { normalizeString } from '../../handler/ListTicketKnowledgeHandler';

const RenderAutoCompleted = ({
    optionList,
    setOptionList,
    selectedOptionsValue,
    argsCommon,
    optionType,
    defaultDrillDownData
}) => {
    const [hasMore, setHasMore] = useState(true);
    const [searchKeyword, setSearchKeyword] = useState("");
    const debouncedInputValue = useDebounce(searchKeyword, 500);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [isSearching, setIsSearching] = useState(false);
    const scrollPositionRef = useRef(0);

    useEffect(() => {
        setHasMore(true);
        scrollPositionRef.current = 0;
        // handle search options
        if (Utils.isEmptyString(debouncedInputValue)) return;
        setIsSearching(true)

        handleLoadMore(debouncedInputValue)
            .finally(() => setIsSearching(false))

    }, [debouncedInputValue]);

    const displayedOptions = useMemo(() => {
        const keyword = normalizeString(debouncedInputValue);

        let baseList = optionList;
        if (keyword) {
            baseList = optionList.filter((option) =>
                normalizeString(option.label).includes(keyword)
            );
        }

        return baseList.slice(0, optionList.length);
    }, [debouncedInputValue, optionList]);

    const handleLoadMore = async (queryKeyword = '', lastItem = null) => {
        let listOptionS3 = defaultDrillDownData.filter(option => option.itemListS3Path);
        if (Utils.isEmptyArray(listOptionS3)) return [];
        listOptionS3 = listOptionS3.map(option => {
            const { child, ...rest } = option; 
            return rest;
        });
        const params = {
            getApiType: Constant.GET_API_PUBLIC_TYPE.DRILLDOWN_GET_SUGGEST_TAG_OPTIONS,
            listOptionS3: listOptionS3,
            limit: Constant.DRILLDOWN_SUGGEST_OPTION_VISIBLE_SIZE,
            lastItem: lastItem,
            queryKeyword: queryKeyword,
            clientListId: optionList.map(opt => ({id: opt.id, groupId: opt.groupId}))
        };
        try {
            const res = await getPublicAPI(null, params);
            const listSuggestOptions = Utils.convertJSONDataToObject(res?.payload)?.listSuggestOptions || [];
            if (Utils.isEmptyArray(listSuggestOptions)) {
                return [];
            }
            
            setOptionList(prev => {
                const merged = [...prev, ...listSuggestOptions];
                const unique = Array.from(new Map(merged.map(item => [item.id, item])).values());
                return unique;
            });

            return listSuggestOptions
        } catch (err) {
            console.error("scroll listOptionS3 err >>> ", err);
        }
    };

    return (
        <div className="search-option-tag-input">
            <Autocomplete
                className="search-option-tag-content"
                multiple
                freeSolo
                
                loading={isSearching}
                loadingText={<CircularProgress color="primary" size="1rem" />}
                options={displayedOptions}
                filterSelectedOptions
                getOptionLabel={(option) => option?.label || ''}
                ListboxComponent={(props) => (
                    <ListboxWithInfiniteScroll
                        {...props}
                        optionList={optionList}
                        isLoadingMore={isLoadingMore}
                        setIsLoadingMore={setIsLoadingMore}
                        handleLoadMore={handleLoadMore}
                        searchKeyword={debouncedInputValue}
                        scrollPositionRef={scrollPositionRef}
                        hasMore={hasMore}
                        setHasMore={setHasMore}
                    />
                )}
                value={selectedOptionsValue}
                onChange={(e, newValue) => onChangeSelectedOptions(e, newValue, argsCommon, optionType)}
                
                onInputChange={(e, newInputValue) => setSearchKeyword(newInputValue)}
                renderInput={params => (
                    <TextField {...params} variant="outlined" className="form-control" />
                )}
                renderOption={(propsRenderOption) => (
                    <OverFlowTooltipWithTabsMui value={`${propsRenderOption.label}`} className="autoCompleteItemTagFieldLabel"/>
                )}
                renderTags={(selectedOptions, getTagProps) =>
                    selectedOptions.map((option, index) => {
                        return (
                            <Chip
                                key={option?.id}
                                label={<OverFlowTooltipWithTabsMui value={option.label}/>}
                                {...getTagProps({ index })}
                            />
                        );
                    })
                }
            />
        </div>
    );
};

RenderAutoCompleted.prototype = {
    optionList: PropTypes.any,
    selectedOptionsValue: PropTypes.any,
    argsCommon: PropTypes.any,
    optionType: PropTypes.any
}

export default RenderAutoCompleted;